import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fbd7183"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "result" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "加密完成", -1))
const _hoisted_3 = { class: "doc-title" }
const _hoisted_4 = { class: "doc-link" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-code-text" }, "访问码", -1))
const _hoisted_6 = {
  key: 0,
  class: "doc-share"
}
const _hoisted_7 = { class: "qr-code" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share-tip" }, [
  /*#__PURE__*/_createTextVNode(" 将二维码分享给好友 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 对方扫一扫即可阅览 ")
], -1))
const _hoisted_9 = { class: "btn-group" }

import { computed, ref, onMounted, defineAsyncComponent } from "vue";
import { ElMessage } from "element-plus";
import QrcodeVue from "qrcode.vue";
import ClipboardJS from 'clipboard';
import { useUser } from "@/composable/useUser"
import { useRouter, useRoute } from "vue-router";
import { fileShareApi } from "@/api/file"


export default /*#__PURE__*/_defineComponent({
  __name: 'result',
  setup(__props) {

_useCssVars(_ctx => ({
  "cb8a593a": (bg),
  "d960f59e": (qrCodeBg),
  "a5c0cda2": (bg2)
}))

const router = useRouter();
const route = useRoute();
const { handleVipTip } = useUser()

// 导入组件
// const QrcodeVue = defineAsyncComponent(() => import("qrcode.vue"));
/**
 *  加密链接
 */
const links = ref<any>([]);

/**
 * 是否是批量
 */
const isBatch = computed(() => {
  return links.value.length > 1;
});

/**
 * 批量加密连接
 */
const linkStr = computed(() => {
  return links.value.map((link: any) => link.copy).join('\n');
});

/**
 * 复制链接
 */
const copyLink = async (type = '') => {
  if (type === 'all') {
    try {
      const status = await handleVipTip('batch_sharing', true);
      if (!status) return false
      else {
        new ClipboardJS('.copy-btn-all');
        ElMessage.success('复制成功');
      }
    } catch (error) {
      console.log(error);
    }
  } else {
    new ClipboardJS('.copy-btn');
    ElMessage.success('复制成功');
  }
};

/**
 * 继续加密
 */
const toPdf = () => {
  router.push('/pdf/index');
}

/**
 * 跳转管理文档页
 */
const toManage = () => {
  router.push('/member/file');
}

const fileIds = ref<any>('')

// 获取加密成功文件列表
const getShareList = async () => {
  const res: any = await fileShareApi({ id: fileIds.value })
  if (res && res.length){
    links.value = res
  }else{
    await router.replace('/')
  }
}

onMounted(() => {
  let { ids } = route.params
  if (ids) fileIds.value = ids, getShareList()
  else {
    ElMessage.error('参数错误')
    setTimeout(() => {
      router.push('/')
    }, 1500)
  }
})

// css 所需背景图
const bg = `url(${require('@/assets/login/bg.png')})`;
const bg2 = `url(${require('@/assets/pdf/bg2.png')})`;
const qrCodeBg = `url(${require('@/assets/pdf/ewm_bg.png')})`;

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(['card', { batch: isBatch.value }])
    }, [
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "wrap",
            key: index
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_input, {
                modelValue: item.share_url,
                "onUpdate:modelValue": ($event: any) => ((item.share_url) = $event),
                disabled: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              (item.password?.length > 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_5,
                    _createVNode(_component_el_input, {
                      class: "input-code",
                      modelValue: item.password,
                      "onUpdate:modelValue": ($event: any) => ((item.password) = $event),
                      disabled: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: copyLink,
                class: "copy-btn",
                "data-clipboard-text": item.copy,
                color: "#FE0000"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 复制分享链接 ")
                ]),
                _: 2
              }, 1032, ["data-clipboard-text"])
            ])
          ]))
        }), 128)),
        (!isBatch.value && links.value[0])
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(QrcodeVue, {
                  value: links.value[0]?.share_url,
                  size: 1000
                }, null, 8, ["value"])
              ]),
              _hoisted_8
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (copyLink('all'))),
        class: "copy-btn-all",
        "data-clipboard-text": linkStr.value
      }, {
        default: _withCtx(() => [
          _createTextVNode("一键复制")
        ]),
        _: 1
      }, 8, ["data-clipboard-text"]),
      _createVNode(_component_el_button, {
        type: "primary",
        color: "#FE0000",
        onClick: toPdf
      }, {
        default: _withCtx(() => [
          _createTextVNode("继续加密")
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        onClick: toManage,
        class: "to-manage"
      }, {
        default: _withCtx(() => [
          _createTextVNode("管理我的文档")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})